import { SidebarBoxKey } from 'AdmissionsGuidance';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigationHelper } from 'FrontRoyalAngular';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

export function TranscriptsBoxComponent() {
    const { t } = useTranslation('back_royal', { keyPrefix: 'transcriptsBox' });
    const { loadFaqUrl } = useNavigationHelper();
    const buttons = useMemo<ButtonConfig[]>(
        () => [
            {
                id: 'button_learn_more',
                text: t('buttonLearnMore'),
                onPress: () => loadFaqUrl('/help/how-can-i-request-my-transcript', '_blank'),
            },
        ],
        [t, loadFaqUrl],
    );
    return <TranscriptsBoxPresentation buttons={buttons} />;
}

export function TranscriptsBoxPresentation({ buttons }: { buttons: ButtonConfig[] }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'transcriptsBox' });
    return (
        <BasicDesktopBox boxKey={SidebarBoxKey.transcripts} headerText={t('heading')} buttons={buttons}>
            {t('content')}
        </BasicDesktopBox>
    );
}

export const TranscriptsBox = memo(TranscriptsBoxComponent) as unknown as typeof TranscriptsBoxComponent;
